import { CardType, CreditCardBrand, Nullable } from '@types-internal';

// For the list of card brands supported on the web by Adyen: https://docs.adyen.com/payment-methods/cards/custom-card-integration#supported-card-types
// For the variants: https://docs.adyen.com/development-resources/paymentmethodvariant
export type AdyenCardBrand =
  | 'amex'
  | 'cartebancaire'
  | 'diners'
  | 'maestro'
  | 'mc'
  | 'visa'
  | 'bcmc';

// A map of AdyenCardBrand - zppCardBrand. Used to get the zpp card brand from a given Adyen brand.
export const creditCardBrandOfAdyenBrand: Record<AdyenCardBrand, CreditCardBrand> = {
  amex: 'american_express',
  cartebancaire: 'carte_bancaire',
  diners: 'diners_club',
  maestro: 'maestro',
  mc: 'master_card',
  visa: 'visa',
  bcmc: 'bcmc',
};

// A map of zppCardBrand - AdyenCardBrand. Used to get the Adyen card brand from a given zpp brand.
export const adyenBrandOfCreditCardBrand: Record<CreditCardBrand, Nullable<AdyenCardBrand>> = {
  american_express: 'amex',
  carte_bancaire: 'cartebancaire',
  diners_club: 'diners',
  maestro: 'maestro',
  master_card: 'mc',
  other: null,
  visa: 'visa',
  bcmc: 'bcmc',
};

// A map between AdyenCardBrand - CardType. Used to get the CardType from a given AdyenCardBrand.
export const cardTypeOfAdyenCardBrand: Record<AdyenCardBrand, CardType> = {
  amex: 'american-express',
  cartebancaire: 'cartebancaire',
  diners: 'diners-club',
  maestro: 'maestro',
  mc: 'mastercard',
  visa: 'visa',
  bcmc: 'bcmc',
};

export type AdyenCreditCardData = {
  brand: string | null;
  holderName: string;
  encryptedCardNumber: string;
  encryptedExpiryMonth: string;
  encryptedExpiryYear: string;
  encryptedSecurityCode: string;
};

export type BrowserInfo = {
  browserUserAgent: string;
  browserColorDepth: number;
  browserLanguage: string;
  browserScreenHeight: number;
  browserScreenWidth: number;
  browserTimeZoneOffset: number;
  browserJavaEnabled: boolean;
};

export type AdyenEnvironment = 'test' | 'live';

export interface AdyenConfig {
  adyenEnvironment: AdyenEnvironment;
  clientKey: string;
}
